import { ParentQRId } from "../Constants/assignQR";
export const updateParentByQRId= (qrData) => {
    return {
        type: ParentQRId.PUT_PARENTQRID,
        payload: qrData
    };
};
